import 'css-chunksrc/client/pages/planzoneMembersPage/groupsList/styles.scss';export default {
  "groupsList": "_groupsList_1366w_1",
  "group": "_group_1366w_1",
  "groupHeader": "_groupHeader_1366w_24",
  "name": "_name_1366w_34",
  "members": "_members_1366w_40",
  "icon": "_icon_1366w_45",
  "resourcesList": "_resourcesList_1366w_51",
  "heading": "_heading_1366w_58",
  "label": "_label_1366w_68",
  "cogWheel": "_cogWheel_1366w_77",
  "cogIcon": "_cogIcon_1366w_86",
  "main": "_main_1366w_93",
  "list": "_list_1366w_102",
  "item": "_item_1366w_107",
  "contextualMenu": "_contextualMenu_1366w_111",
  "button": "_button_1366w_115",
  "toggleIcon": "_toggleIcon_1366w_132",
  "actions": "_actions_1366w_138",
  "action": "_action_1366w_138",
  "buttonText": "_buttonText_1366w_155"
};